import { UPDATE_BREADCRUMBS, GENERIC_ERROR } from "./types";

export const updateBreadcrumbs = (crumbs) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_BREADCRUMBS,
      payload: crumbs,
    });
  } catch (error) {
    dispatch({
      type: GENERIC_ERROR,
      payload: { msg: "Unable to update breadcrumbs. Something broke." },
    });
  }
};
